export default "__VITE_ASSET__sSQFVtRi__"